import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FormValidationService } from 'src/app/common/services/form-validation.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import {
  SezioneEconomicaFondoOneriFormComponent
} from '../../../form/sez-economica/sezione-economica-fondo-oneri-form.component';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { FondoOnere } from '../../../models/fondo-onere';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';

@Component({
    selector: 'div [sezione-economica-fondo-oneri-form-add]',
  templateUrl: '../../../form/sez-economica/sezione-economica-fondo-oneri-form.component.html'
})

export class SezioneEconomicaFondoOneriAddComponent extends SezioneEconomicaFondoOneriFormComponent implements OnInit {
  private fondoOnere: FondoOnere;
  private urlUpdate: string;
  private urlReadSezioneEconomica: string;
  private urlReadSezioneLegali: string;
  private fascicolo: FascicoloFull;

  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected formValidationService: FormValidationService) {
    super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Inserimento Fondo Oneri');
    this.isInserimento(true);
  }

  getFondoOnere() {
    return this.fondoOnere;
  }

  getUrlReadSezioneEconomica() {
    return this.urlReadSezioneEconomica;
  }

  getUrlReadSezioneLegali() {
    return this.urlReadSezioneLegali;
  }


  getRequest(request: FondoOnere) {
    let idSezione: string = PropertiesSettings.NEW_SEZIONE;
    if (this.sezione) {
      idSezione = this.sezione.id;
    }
    this.operationService.addFondoOneri(this.urlUpdate, request, idSezione, this.fascicolo.id).subscribe((response: any) => this.datiOneri(response));
  }

  datiOneri(response: SezioneEconomicaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica, fondoOnere: FondoOnere, fascicolo: FascicoloFull, urlUpdate: string,
              urlReadSezioneEconomica: string, urlReadSezioneLegali: string) {
    this.fascicolo = fascicolo;
    this.fondoOnere = fondoOnere;
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    this.urlReadSezioneEconomica = urlReadSezioneEconomica;
    this.urlReadSezioneLegali = urlReadSezioneLegali;
    this.readSezioneEconomica(fascicolo.idSezioneDatiEconomici);
    this.readSezioneLegali(fascicolo.idSezioneLegali);
    this.createForm();
    this.populateSelect();
  }

}
